import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'
import AudioAssetSettingsForm from 'components/AssetPanels/Audio/Settings'
import * as PT from '~/PropTypes'
import { VideoAsset, ImageAsset, AudioAsset, TextAsset, TransitionAsset } from '~/models/Asset'
import TextAssetSettingsForm from '~/components/AssetPanels/Text/Settings'
import TransitionSettingsForm from '~/components/AssetPanels/Transition/Settings'
import ImageAssetSettingsForm from './ImageForm'
import VideoAssetSettingsForm from './VideoForm'

// import AudioTracks from './AudioTracks'

function getSettingsForm(asset) {
  switch (asset?.constructor) {
    case VideoAsset:
      return VideoAssetSettingsForm
    case ImageAsset:
      return ImageAssetSettingsForm
    case AudioAsset:
      return AudioAssetSettingsForm
    case TextAsset:
      return TextAssetSettingsForm
    case TransitionAsset:
      return TransitionSettingsForm
    default:
      return null
  }
}

function MediaAssetSettingsForm(props, ref) {
  const { asset } = props
  const MediaForm = getSettingsForm(asset)
  return MediaForm && <div style={{ overflow: 'hidden', height: '100%' }}><MediaForm {...props} ref={ref} /></div>
}

export default forwardRef(MediaAssetSettingsForm)

MediaAssetSettingsForm.defaultProps = {
  type: '',
  asset: null,
  hideScrollBar: false,
}

MediaAssetSettingsForm.propTypes = {
  asset: PropTypes.oneOfType([ PT.VideoAsset, PT.ImageAsset,
    PT.AudioAsset, PT.TextAsset, PT.TransitionAsset ]),
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  hideScrollBar: PropTypes.bool,

}
